/**
 * SEO configuration constants
 */

type GlobalWithProcessEnv = typeof globalThis & {
  process?: { env?: Record<string, string | undefined> };
};

const getNodeEnv = () => {
  if (typeof globalThis === "undefined") return undefined;
  return (globalThis as GlobalWithProcessEnv).process?.env?.NODE_ENV;
};

export const SEO_CONFIG = {
  baseUrl: getNodeEnv() === "production" ? "https://version2.io" : "http://localhost:3000",
  siteName: "Version2",
  twitterHandle: "@version2io",
  defaultImage: "/og-image.png",
};
